import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import { PaymentResponse } from '../../../../../api/types/payments/gateway/payment-gateway-response';

export const getPaymentLinkOperations = async (
  allocationId: number,
  userId: number,
  amount: number,
  setPaymentLink: (
    link: (PaymentResponse & { allocationId: number }) | null,
  ) => any,
) => {
  try {
    const asd = await appApi.getPaymentLink(allocationId, userId, amount);
    if (!asd.data.body.url.length) {
      throw new Error('Link is not valid');
    }

    setPaymentLink({ ...asd.data.body, allocationId: allocationId });
  } catch (e) {
    console.error(`getPaymentLinkOperations is failed with the error: ${e}`);
    toast.error('יצירת לינק לתשלום נכשלה, נסה שוב בעוד מספר רגעים');
  }
};
